<template>
  <component
    v-bind="allProps"
    v-on="$listeners"
    :is="selectedCarousel"
  >
    <template
      v-for="(_, slotName) in $slots"
      v-slot:[slotName]
    >
      <slot :name="slotName" />
    </template>
  </component>
</template>

<script>
import CarouselComponent from './CarouselComponent.vue'
import ImageCarouselComponent from './ImageCarouselComponent.vue'

export default {
  name: 'CarouselIndex',
  components: {
    CarouselComponent,
    ImageCarouselComponent
  },
  props: {
    type: {
      type: String,
      default: 'base',
      validator: function (value) {
        return ['base', 'image'].indexOf(value) !== -1
      }
    },
    imageList: Array,
    autoplay: Boolean,
    duration: [ Number, String ],
    title: String,
    itemsPerPage: [ Number, String ]
  },
  computed: {
    allProps () {
      return {
        ...this.$props,
        ...this.$attrs
      }
    },
    selectedCarousel () {
      if (this.type === 'image') {
        return 'ImageCarouselComponent'
      }

      return 'CarouselComponent'
    }
  }
}
</script>
